import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App)
import router from './router'
app.use(router)
import store from './store'
app.use(store)
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus)

import LazyImage from "@/components/LazyImage.vue"
app.component("LazyImage",LazyImage)

import "@/font/font.css"
app.mount('#app')
